import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICostCenter } from "src/models/HumanResources/CostCenters.models";

interface CostCenterState {
  costCenters: ICostCenter[];
  costCenterToEdit: ICostCenter | null;
}

const initialState: CostCenterState = {
  costCenters: [],
  costCenterToEdit: null,
};

const CostCenterSlice = createSlice({
  name: "CostCenter",
  initialState,
  reducers: {
    setCostCenterList: (state, action: PayloadAction<ICostCenter[]>) => {
      state.costCenters = action.payload;
    },
    concatListCostCenter: (
      state: CostCenterState,
      action: PayloadAction<ICostCenter[]>
    ) => {
      state.costCenters = [...state.costCenters.concat(action.payload)];
    },
    setCostCenterToEdit: (state, action: PayloadAction<ICostCenter | null>) => {
      state.costCenterToEdit = action.payload;
    },
    addCostCenter: (state, action: PayloadAction<ICostCenter>) => {
      state.costCenters.push(action.payload);
    },
    updateCostCenter: (state, action: PayloadAction<ICostCenter>) => {
      let itemIndex = state.costCenters.findIndex(
        item => item.costCenterId === action.payload.costCenterId
      );
      if (itemIndex !== -1) state.costCenters[itemIndex] = action.payload;
    },
    deleteCostCenter: (state, action: PayloadAction<number>) => {
      const newArray = state.costCenters.filter(
        item => item.costCenterId !== action.payload
      );
      state.costCenters = newArray;
    },
  },
});

export const {
  setCostCenterList,
  concatListCostCenter,
  setCostCenterToEdit,
  addCostCenter,
  updateCostCenter,
  deleteCostCenter,
} = CostCenterSlice.actions;

export default CostCenterSlice.reducer;
